export const reduxKey = '@@DreamupForm';

//# sourceMappingURL=constants.js.map